import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { CommentReactions } from '@root/entities/comment'

import { CommentItemButtonReply } from '../comment-item/comment-item-button-reply'

import type { Comment } from '@root/entities/comment'

type CommentReactionProps = React.ComponentPropsWithoutRef<typeof Root> & {
  comment: Comment.Comment
  onReaction: (type: CommentReactions.Reaction) => void
  onReply: () => void
}

const REACTION_TYPE_MAP: Record<CommentReactions.Reaction, string> = {
  [CommentReactions.ReactionLike]: '👍',
  [CommentReactions.ReactionDislike]: '👎',
}

export const CommentReaction = ({
  comment,
  onReaction,
  onReply,
  ...props
}: CommentReactionProps) => {
  const upvoteCount =
    comment.reactions?.[CommentReactions.ReactionLike]?.count ?? 0
  const downvoteCount =
    comment.reactions?.[CommentReactions.ReactionDislike]?.count ?? 0
  const handleUpvote = () => onReaction(CommentReactions.ReactionLike)
  const handleDownvote = () => onReaction(CommentReactions.ReactionDislike)

  return (
    <Root {...props}>
      <ReactionButton size="xxs" variant="soft" onClick={handleUpvote}>
        <span>{REACTION_TYPE_MAP[CommentReactions.ReactionLike]}</span>
        {upvoteCount ? <span>{upvoteCount}</span> : undefined}
      </ReactionButton>
      <ReactionButton size="xxs" variant="soft" onClick={handleDownvote}>
        <span>{REACTION_TYPE_MAP[CommentReactions.ReactionDislike]}</span>
        {downvoteCount ? <span>{downvoteCount}</span> : undefined}
      </ReactionButton>
      <CommentItemButtonReply onReply={onReply} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  gap: 6px;

  padding-block: 8px;
`

const ReactionButton = styled(Button)`
  background: var(--backgroundA-4);

  color: var(--text-12);
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  gap: 2px;
  font-size: 10px;
  font-weight: 600;
`
